import React from 'react';
import {Helmet} from 'react-helmet';
import Typography from '@material-ui/core/Typography'
import{
    Col,
    Grid,
    Row
} from 'react-flexbox-grid';
import { Link } from 'react-router-dom';
import Img from 'gatsby-image'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import PageTitle from '../../components/page-title'


import HorizontalCard from '../../components/horizontal-card';

export default class InitiativesPage extends React.Component{
    render(){
	let positions = [
	    {
		title: "Designer",
		description: "We need some help defining and refining our visual identity. No major overhauls; just tweaking our colors, fonts, common design elements, etc. This will apply to our web presence, our app, and our print material.",
		commitment: "approximately 10 hours, one time commitment",
		requirements: "Strong visual communication skills"
	    },
	    {
		title: "Social Media Manager",
		description: "We need someone to maintain a consistent social media presence. For most days, this will be sharing news, updates, and articles on food security issues. When we are running specific marketing campaigns, the social media manager will work with other team members to highlight those messages. Using Buffer.com, multiple posts can be queued up for the week.",
		commitment: "approximately 1-2 hours a week",
		requirements: "Ability to write short, tantalizing summaries for posts"
	    },
	    {
		title: "Food Item Procurement",
		description: "As we roll out our Smart Pantry, we need to establish business partnerships to stock them with appropriate food items. This includes both the items that we distribute for free and items we sell at a premium.",
		commitment: "Team member, long term",
		requirements: "Strong written communication skills, great interpersonal skills, eye for business and unit economics"
	    },
	    {
		title: "Junior Computer Engineer",
		description: "Our digital products, namely the website and app, need occassional maintenance. This includes bug fixes, updates, implementing minor features, and extending existing features, to name a few. This position will work with guidance and support from senior engineers.",
		commitment: "Fluctuates; 5-10 hours per week during high need times, 2-3 hours during low need times",
		requirements: "NodeJS, AngularJS, and git knowledge"
	    },
	    {
		title: "Legal Services Advisor",
		description: "We need someone to advise and oversee some miscellaneous legal services, namely copyright and patenting.",
		commitment: "approximately 10 hours, one time commitment",
		requirements: "relevant legal knowledge"
	    },
	]

	return[
	    
		<PageTitle 
			titles={{
				title: "Join Our Team"
			}}
		/>,

	    <div style={this.props.transition && this.props.transition.style}
		 className="section white slim">
		<Helmet>
		    <title>
			Join Our Team | Share Meals
		    </title>
		</Helmet>
		<Grid style={{paddingBottom: "5rem", paddingTop: "2rem"}}>
		    <Row>
			<Col>
			    <p>
				As Share Meals begins to grow, we need your help to ensure that we keep operating at our maximum potential. Here are a few ways that you can help; we're also open to any suggestions you have! To follow up, email us at <a href="mailto:nucleus@sharemeals.org">nucleus@sharemeals.org</a>
			    </p>
			</Col>
		    </Row>
		    {positions.map(function(position, index){
		    return(
			 <Row key={index} style={{marginTop: '2rem'}}>
			     <Col md={12}
				  lg={3}>
				 <h3 class="title" style={{marginTop: 0}}>
				     {position.title}
				 </h3>
			     </Col>
			     <Col md={12}
				  lg={9}>
				 <p><strong>Description</strong> {position.description}</p>
				 <p style={{marginTop: '.5rem'}}><strong>Requirements</strong> {position.requirements}</p>
				 <p style={{marginTop: '.5rem'}}><strong>Commitment</strong> {position.commitment}</p>
			     </Col>
			 </Row>
			     )
			 })}
		</Grid>
	    </div>
	];
    }
}



// WEBPACK FOOTER //
// ./src/pages/join-our-team/index.jsx